import { render, staticRenderFns } from "./ArticleListCard.vue?vue&type=template&id=64bccdf6&scoped=true&"
import script from "./ArticleListCard.vue?vue&type=script&lang=js&"
export * from "./ArticleListCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListCard.vue?vue&type=style&index=0&id=64bccdf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bccdf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
